import propTypes from 'prop-types';
import * as S from './styles';

const HostMessage = ({ message, color }) => (
  <S.Message $color={color}>{message}</S.Message>
);

HostMessage.propTypes = {
  message: propTypes.string.isRequired,
  color: propTypes.string,
};

HostMessage.defaultProps = {
  color: undefined,
};

export default HostMessage;
